$(function () {
    // let App = window.App;
    // App.registration = {};
    // App.registration.ajax = false;

    $('#registrationForm').validate({
        rules: {
            phone: {
                phoneRU: true
            },
            password_confirmation: {
                equalTo: "#registrationPassword"
            }
        }
    });

    /* TODO: send form moved to App.modal.submitForm
    $(document).on('submit', '#registrationForm', function (e) {
        e.preventDefault();

        let $form = $(this);
        let prevRequest = App.registration.ajax;

        App.login.ajax = $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function () {
                if (prevRequest) {
                    prevRequest.abort();
                }

                $form.find('button[type="submit"]').addClass('is-loading');
            },
            success: function (response) {
                if (response.status === 'ERROR') {
                    $form.validate().showErrors(response.errors);
                }
            },
            complete: function () {
                App.registration.ajax = false;
                $form.find('button[type="submit"]').removeClass('is-loading');
            }
        });
    }); */
});